import React, {useState} from "react";
import {Button, Form} from "react-bulma-components";
import axios from "axios";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {useDispatch} from "react-redux";
import useInlineEditButton from "../../../hooks/useInlineEditButton";

function FitterRow({fitter, dataFresh, index, onChange, onSave}){
    const dispatch = useDispatch();
    const [editable, setEditable] = useState(false);


    const onDelete = () => {
        const url = "api/fitter/" + fitter.id;
        const conf = { method: "delete", url };
        axios(conf).then(response =>
            dispatch(createSetDataFreshAction(dataFresh + 1))
        );
    };



    const onCheck = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !fitter[e.target.name]
            }
        }
        onChange(toUpdate, index)
    }

    return (
        <tr key={fitter.id}>
            <td>{fitter.name}</td>
            <td>
                <Form.Field className={"has-addons"}>
                    <Form.Control>
                        <Form.Checkbox
                            checked={fitter.hidden}
                            name={"hidden"}
                            onChange={onCheck}
                        />
                    </Form.Control>
                    {useInlineEditButton({
                        show: true,
                        onSave: () => onSave(setEditable, fitter),
                        editable,
                        setEditable,
                        disabled: false
                    })}
                </Form.Field>
            </td>
            <td>
                <Button
                    color={"danger"}
                    onClick={onDelete}
                >
                    Delete X
                </Button>
            </td>
        </tr>
    )

}

export default FitterRow;

